var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlindfolds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 42.7556C36.6846 42.926 36.2144 43.2803 36.0082 43.4292C33.9483 44.9182 31.575 45.7102 29.0267 45.3059C21.431 44.1004 16.86 33.3061 15.8102 26.5218L15 21.2857L19.2908 24.3942C20.8656 25.5351 24.3096 26.5199 26.2432 26.2655C29.3464 25.8573 32.3663 26.6189 34.9914 28.2897C35.7618 28.7799 36.3984 29.2759 37 29.8178C37.6016 29.2759 38.2382 28.7799 39.0086 28.2897C41.6337 26.6189 44.6536 25.8573 47.7568 26.2655C49.6904 26.5199 53.1344 25.5351 54.7092 24.3942L59 21.2857L58.1898 26.5218C57.8277 28.8621 57.1679 31.2008 56.2996 33.4028C54.3906 38.2437 50.5813 44.4158 44.9733 45.3059C42.425 45.7102 40.0517 44.9182 37.9918 43.4292C37.7856 43.2803 37.3154 42.926 37 42.7556ZM47.6453 33.2286C46.6519 32.6937 43.4623 31.3346 41.34 34.5452C37.303 40.6542 45.4909 37.1847 47.2397 36.0229C48.1824 35.3966 49.1856 34.058 47.6453 33.2286ZM26.3547 33.2286C27.348 32.6937 30.5377 31.3346 32.6599 34.5452C36.697 40.6542 28.5091 37.1847 26.7602 36.0229C25.8175 35.3966 24.8144 34.058 26.3547 33.2286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1161 51.6266L58.1162 26.8508C57.7418 29.0398 57.1119 31.2198 56.2995 33.2801C56.1062 33.7704 55.8933 34.2745 55.6608 34.7852C55.6609 34.785 55.6609 34.7855 55.6608 34.7852V51.6266C55.6608 52.2273 56.2104 52.7143 56.8884 52.7143C57.5665 52.7143 58.1161 52.2273 58.1161 51.6266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindfolds);
export default __webpack_public_path__ + "static/media/blindfolds.f1a3fa2bc8b96149f6db8c8c89cd76c7.svg";
export { ForwardRef as ReactComponent };